export default `---
slug: philippines
country: Philippines
countryCode: PHL
continent: Asia
year: 2023
title: "Philippines"
description: "7,000+ islands, crystal water, and the warmest hospitality in Southeast Asia."
thumbnail: /images/travels/PHL/philippines_thumb.jpg
relatedLinks: []
---
![philippines](/images/travels/PHL/philippines_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Philippines and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
